import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { Crfs } from "@pages/ecoa/Crfs";
import { Visits } from "@pages/ecoa/Visits";
import { EcoaVisitRoute } from "./EcoaVisitRoute";
import { useCrfSpecContext } from "../CrfSpecContext";

// interface EcoaRouteProps {}

export function EcoaRoute() {
  const match = useRouteMatch();
  const { crfSpec } = useCrfSpecContext();

  // NOTE: context 사용하여 Props 드릴링 개선 필요(2024.07.05)
  return (
    <Switch>
      <Route
        path={`${match.url}/visits/:folderId/:visitId/:visitSeq/:crfPageId/:crfPageSeq`}
        component={() => <EcoaVisitRoute studySpec={crfSpec!} />}
      />
      <Route path={`${match.url}/visits`} component={() => <Visits studySpec={crfSpec!} />} />
      <Route path={`${match.url}/crfs/:folderId/:visitId/:visitSeq`} component={() => <Crfs studySpec={crfSpec!} />} />
      {/* NOTE: 220905 하위 호환을 위해 해당 path 남겨둠, 배포 완료 이후 아래 라인 삭제 필요 */}
      <Route path={`${match.url}/crfs/:folderId/:visitId`} component={() => <Crfs studySpec={crfSpec!} />} />
      <Redirect from="*" to="/404?br" />
    </Switch>
  );
}
